import { COLORS } from "shared/consts";
import { toRem } from "shared/helpers";
import styled from "styled-components";

export const NewEntrieWrapper = styled.form`
  min-height: 100%;
  display: flex;
  flex-direction: column;

  @media (width < ${toRem(768)}) {
    width: 100vw;
  }
`;

type NewEntrieHeadProps = {
  $isMobile?: boolean;
};
export const NewEntrieHead = styled.div<NewEntrieHeadProps>`
  padding: ${toRem(16)};
  display: flex;
  flex-direction: ${(props) => (props.$isMobile ? "row-reverse" : "column")};
  gap: ${toRem(12)};
  justify-content: space-between;
  align-items: ${(props) => (props.$isMobile ? "center" : "initial")};
`;

export const NewEntrieTitle = styled.h2`
  display: flex;
  gap: ${toRem(12)};
  justify-content: space-between;
  font-weight: 700;
  font-size: ${toRem(22)};
  line-height: ${24 / 22};
  color: ${COLORS.FG.DEFAULT};

  @media (width < ${toRem(768)}) {
    font-size: ${toRem(16)};
  }

  button {
    color: ${COLORS.ACCENT.DEFAULT};
    font-size: ${toRem(16)};
  }
`;

export const NewEntrieBody = styled.div`
  padding: ${toRem(16)};
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;

  @media (width >= ${toRem(540)}) {
    width: ${toRem(540)};
  }
  @media (width < ${toRem(540)}) {
    width: 100vw;
  }
`;

type NewEntrieRowProps = {
  $alignItems?: React.CSSProperties["alignItems"];
};

export const NewEntrieRow = styled.div<NewEntrieRowProps>`
  display: flex;
  align-items: ${(props) => props.$alignItems || "center"};
  gap: ${toRem(12)};
  margin: ${toRem(6)} 0;
  position: relative;

  &,
  & > * {
    word-break: break-all;
    max-width: 100%;
    text-overflow: ellipsis;
    &:not(:has(.dropdown-menu)):not(:has(.taggroup)):not(._has-overflow) {
      overflow: hidden;
    }
  }
  & .tagitem.tagitem--primary[aria-invalid="true"] {
    background-color: ${COLORS.BG.SURFACE1} !important;
  }

  & .tagitem.tagitem--primary[aria-invalid="true"] .tagitem__label {
    color: ${COLORS.FG.DEFAULT} !important;
  }

  > span {
    flex: 0 0 ${toRem(120)};
    font-weight: 500;
    font-size: ${toRem(14)};
    line-height: ${20 / 14};
  }

  @media (width >= ${toRem(540)}) {
    .popover__root,
    .dropdown-menu-root {
      min-width: ${toRem(220)};
      max-width: ${toRem(220)};
    }
  }

  .tagitem__label {
    display: flex;
    align-items: center;
    gap: ${toRem(8)};

    img {
      max-width: ${toRem(20)};
      aspect-ratio: 1;
      border-radius: 50%;
    }
  }

  i {
    color: ${COLORS.FG.MUTED};
  }
`;

export const NewEntrieBorder = styled.div`
  width: 100%;
  height: ${toRem(1)};
  margin: ${toRem(6)} 0;
  background-color: ${COLORS.BORDER.MUTED};
`;

export const NewEntrieAuthor = styled.div`
  display: flex;
  align-content: baseline;
  gap: ${toRem(8)};
  padding: ${toRem(4)} ${toRem(12)} ${toRem(4)} ${toRem(4)};
`;

export const NewEntrieDictionariesPopover = styled.div`
  padding: ${toRem(8)};
  display: flex;
  flex-direction: column;
  gap: ${toRem(4)};
  max-height: ${toRem(250)};
  overflow: hidden auto;
  background-color: ${COLORS.BG.PAGE};
  position: absolute;
  top: calc(100% + ${toRem(6)});
  left: ${toRem(132)};
  width: calc(100% - ${toRem(132)});
  box-shadow:
    0px 32px 32px 0px ${COLORS.NEUTRAL.CONTAINER_SOFT},
    0px 0px 32px 0px ${COLORS.NEUTRAL.CONTAINER_DEFAULT};
  z-index: 3;

  span {
    padding: ${toRem(6)} ${toRem(12)};
    cursor: pointer;
    user-select: none;
    transition: background-color 0.3s ease 0s;
    font-size: ${toRem(12)};
    line-height: ${16 / 12};

    @media (any-hover: hover) {
      &:hover {
        background-color: ${COLORS.NEUTRAL.CONTAINER_SOFT};
      }
    }
  }
`;
type NewEntrieTextAreaWrapperProps = {
  $height?: string;
};
export const NewEntrieTextAreaWrapper = styled.div<NewEntrieTextAreaWrapperProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: ${toRem(4)};
  flex: 1 1 auto;

  textarea {
    border-radius: ${toRem(8)};
    resize: none;
    height: ${(props) => props.$height || toRem(76)};
    border: ${toRem(2)} solid ${COLORS.BORDER.MUTED};
    padding: ${toRem(8)} ${toRem(12)};
    transition: all 0.3s ease 0s;
  }
`;

export const NewEntrieLength = styled.div`
  font-size: ${toRem(12)};
  line-height: ${16 / 12};
  color: ${COLORS.FG.MUTED};
`;

export const NewEntrieFooter = styled.div`
  padding: ${toRem(12)} ${toRem(16)};
  border-top: ${toRem(1)} solid ${COLORS.BORDER.SOFT};
  display: flex;
  gap: ${toRem(16)};

  @media (width < ${toRem(768)}) {
    display: flex;
    flex-direction: column-reverse;
    gap: ${toRem(12)};
  }
`;

export const NewEntrieFilesWrapper = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: repeat(auto-fit, ${toRem(56)});
  gap: ${toRem(4)};
  flex: 1 1 auto;

  input {
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    opacity: 0;
  }
`;

export const NewEntrieImage = styled.div`
  width: ${toRem(56)};
  height: ${toRem(56)};
  border-radius: ${toRem(8)};
  overflow: hidden;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }

  @media (any-hover: hover) {
    &:hover {
      i {
        opacity: 1;
      }
    }
  }
`;

export const NewEntriePlus = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${toRem(56)};
  height: ${toRem(56)};
  border-radius: ${toRem(8)};
  border: ${toRem(2)} solid ${COLORS.BORDER.MUTED};
  transition: border-color 0.3s ease 0s;
  cursor: pointer;

  path {
    transition: all 0.3s ease 0s;
  }

  @media (any-hover: hover) {
    &:hover {
      border-color: ${COLORS.ACCENT.HOVER};
      path {
        fill: ${COLORS.ACCENT.HOVER};
      }
    }
  }
`;

export const NewEntrieDelete = styled.i`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: ${toRem(2)};
  right: ${toRem(2)};
  background-color: ${COLORS.BG.SURFACE1};
  width: ${toRem(16)};
  height: ${toRem(16)};
  border-radius: ${toRem(6)};
  color: ${COLORS.NEUTRAL.DEFAULT};
  transition: opacity 0.3s ease 0s;
  cursor: pointer;
  opacity: 0;
`;

export const NewEntrieSubtitle = styled.h3`
  color: ${COLORS.FG.SOFT};
  font-weight: 700;
  font-size: ${toRem(12)};
  line-height: ${toRem(16)};
  padding: ${toRem(12)};
`;

export const NewEntrieNewFieldButton = styled.button`
  display: flex;
  align-items: center;
  gap: ${toRem(8)};
  width: 100%;
  padding: ${toRem(12)} ${toRem(16)};
  border: ${toRem(1)} solid ${COLORS.BORDER.DEFAULT};
  border-radius: ${toRem(6)};
  background: transparent;
  color: ${COLORS.FG.DEFAULT};
  font-size: ${toRem(16)};
  font-weight: 500;
  line-height: ${24 / 16};
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    color 0.2s ease;

  &:hover {
    border-color: ${COLORS.BORDER.SOFT};
  }

  &:active {
    border-color: ${COLORS.ACCENT.DEFAULT};
    color: ${COLORS.ACCENT.DEFAULT};
  }
`;

export const HivesSelectWrapper = styled.div`
  position: relative;
  width: 100%;
`;

type HivesSelectButtonProps = {
  $hasError?: boolean;
};
export const HivesSelectButton = styled.button<HivesSelectButtonProps>`
  width: 100%;
  min-height: ${toRem(40)};
  padding: ${toRem(8)} ${toRem(12)};
  border: ${toRem(1)} solid ${props => props.$hasError ? COLORS.ACCENT.DEFAULT : COLORS.BORDER.DEFAULT};
  border-radius: ${toRem(8)};
  background: ${COLORS.BG.SURFACE1};
  color: ${COLORS.FG.DEFAULT};
  font-size: ${toRem(14)};
  font-weight: 400;
  line-height: ${20 / 14};
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    background-color 0.2s ease;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &::after {
    content: '';
    width: ${toRem(20)};
    height: ${toRem(20)};
    background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.29289 7.29289C5.68342 6.90237 6.31658 6.90237 6.70711 7.29289L10 10.5858L13.2929 7.29289C13.6834 6.90237 14.3166 6.90237 14.7071 7.29289C15.0976 7.68342 15.0976 8.31658 14.7071 8.70711L10.7071 12.7071C10.3166 13.0976 9.68342 13.0976 9.29289 12.7071L5.29289 8.70711C4.90237 8.31658 4.90237 7.68342 5.29289 7.29289Z' fill='%23858FA3'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
    flex-shrink: 0;
  }

  &:hover {
    border-color: ${COLORS.BORDER.SOFT};
    background: ${COLORS.BG.ELEVATED.S};
  }

  &:focus {
    border-color: ${COLORS.ACCENT.DEFAULT};
    outline: none;
  }
`;

export const HivesSelectHeader = styled.div`
  padding: ${toRem(12)};
  border-bottom: ${toRem(1)} solid ${COLORS.BORDER.MUTED};
`;

export const HivesSelectRange = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${toRem(8)};

  .input {
    min-width: 0;
  }
`;
